import { Service } from './di-provider';

@Service
export default class LoaderService {
  showLoader() {
    return window.showLoader();
  }
  hideLoader() {
    return window.hideLoader();
  }
}
